import { Typography } from '@mui/material';
import { formatAuditLogDisplayValue } from '@core/utils/auditLog';

interface AuditLogValueProps {
  value: unknown;
}

const AuditLogValue = ({ value }: AuditLogValueProps) => {
  if (value == null) return null;

  const text = formatAuditLogDisplayValue(value);
  const mono = text.includes('\n');

  return (
    <Typography
      variant="body2"
      component={mono ? 'pre' : 'span'}
      sx={{
        m: 0,
        wordBreak: 'break-word',
        ...(mono && {
          fontFamily: 'monospace',
          fontSize: (theme) => theme.typography.caption.fontSize,
          whiteSpace: 'pre-wrap',
        }),
      }}
    >
      {text}
    </Typography>
  );
};

export default AuditLogValue;
